$(document).ready(function(){

  var line = '<div class="dl-separator" style="border: 0;height: 2px;background-image: linear-gradient(to right, transparent, #CCC, transparent); margin-top: 20px; margin-bottom: 20px;"></div>';

    
	$( "#shopify-section-pr_description iframe" ).after( line );
  
	$( "#shopify-section-pr_description iframe" ).before( line );

    //$('.type_featured_collection_owl:contains("/collections/")').hide();

  
});
